import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NotAuthorized = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header headerTitle={"vTest"} />
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="border border-red-500 bg-red-100 text-red-700 p-6 rounded w-full max-w-md text-center">
          <h2 className="text-2xl font-bold mb-4">Access Denied</h2>
          <p className="mb-6">Only admin can access this page.</p>

          <Link
            to="/"
            className="inline-block bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
          >
            Return to Home
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotAuthorized;
